import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { InvoiceDataChangeDTO, MandateSummary } from '@mwe/models';
import { AddressComponent } from '../../../../address/address.component';
import { ProductsSummaryComponent } from '../../products-summary.component';
import { BasicCardComponent } from '../../../../cards/basic-card/basic-card.component';
import { ProductsSummaryInvoiceOldComponent } from '../../products-summary-invoice-old.component';
import { WizardProductCardContainerComponent } from '../../../../product-card/wizard-product-card/wizard-product-card-container.component';
import { formatAccountNumber } from '@mwe/utils';

@Component({
  selector: 'mwe-products-summary-relocation-old-address',
  templateUrl: './products-summary-relocation-old-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AddressComponent, TranslatePipe, BasicCardComponent, ProductsSummaryInvoiceOldComponent, WizardProductCardContainerComponent],
})
export class ProductsSummaryRelocationOldAddressComponent extends ProductsSummaryComponent {
  readonly bankAccountChangeData = input<InvoiceDataChangeDTO>(undefined);

  // mandates are only visible after backend calls were made
  readonly stromGasMandate = computed<MandateSummary>(() => {
    const bankAccountChangeData = this.bankAccountChangeData();
    const stromGas = bankAccountChangeData?.mappingData?.find(data => data.categories.includes('Strom') || data.categories.includes('Gas'));
    if (!stromGas || !stromGas.changeSepaMandat) return undefined;
    if (!bankAccountChangeData.mandatsReferenzMapping || bankAccountChangeData.mandatsReferenzMapping.length === 0) return undefined;

    const mandateReference = bankAccountChangeData.mandatsReferenzMapping.find(
      item => item.vertragskontoNummer === stromGas.accountNumber,
    ).mandatsreferenz;

    return { accountNumber: stromGas.customerNumber, customerNumber: stromGas.accountNumber, mandateReference };
  });

  readonly fernWaermeMandate = computed<MandateSummary>(() => {
    const bankAccountChangeData = this.bankAccountChangeData();
    const fernWaerme = bankAccountChangeData?.mappingData?.find(data => data.categories.includes('Fernwaerme'));
    if (!fernWaerme || !fernWaerme.changeSepaMandat) return undefined;
    if (!bankAccountChangeData.mandatsReferenzMapping || bankAccountChangeData.mandatsReferenzMapping.length === 0) return undefined;

    const mandateReference = bankAccountChangeData.mandatsReferenzMapping.find(
      item => item.vertragskontoNummer === fernWaerme.accountNumber,
    ).mandatsreferenz;

    return { accountNumber: formatAccountNumber(fernWaerme.accountNumber, true), mandateReference };
  });
}
